import { Case, CaseType } from "./Case.types";

export const getDesignatedText = (caseObject: Case) => {
    if (!caseObject.isDesignated) return "";
    switch (caseObject.type) {
        case CaseType.Design:
            return ", International Design Registration";
        case CaseType.Trademark:
            return ", International Protocol (Madrid)";
        default:
            return "";
    }
};

export const isCalculatedRenewal = (caseObject: Case): boolean => caseObject.isCalculatedRenewal === true;

// internalId identifies the renewal record and is shared by a case and its calculated rows, so it cannot be a react key.
// Tables that are not renewals get no rowInternalId from the server and keep the previous key.
export const getCaseRowKey = (caseObject: Case): string => caseObject.rowInternalId ?? `${caseObject.id}${caseObject.country}`;

export const calculatedRenewalTooltip =
    "Designs in this country are renewed every year. This row is therefore an estimate for a future year, calculated from the current year's renewal. The price updates automatically if it changes on the upcoming renewal. Price and status can't be edited here. When the case is given a real renewal date, the row is replaced automatically.";

// updateRenewalStatus and updateRenewalRemark return the real row only. Its data must be mirrored onto the calculated
// rows sharing its internalId without giving them its renewal date, its identity or its renewal status.
export const applyUpdatedCaseToRow = (row: Case, updatedCase: Case): Case => {
    if (row.internalId !== updatedCase.internalId) return row;
    if (!isCalculatedRenewal(row)) return { ...updatedCase, rowInternalId: row.rowInternalId, isCalculatedRenewal: false };

    return {
        ...updatedCase,
        rowInternalId: row.rowInternalId,
        renewalDate: row.renewalDate,
        isCalculatedRenewal: true,
        renewalStatus: undefined,
        renewalRemark: undefined,
    };
};
